import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { DrillDownCategory } from 'types/store/normalized/insights/InsightCatalogue';
import { DrilldownJsonApiResponse } from 'api/normalized/insightDrilldown/InsightDrilldownApi';
import { addRequests } from 'state/normalized/insightDrilldownRequests/insightDrilldownRequestsSlice';
import { addProjects } from 'state/normalized/insightDrilldownProjects/insightDrilldownProjectsSlice';
import { addTasks } from 'state/normalized/insightDrilldownTasks/insightDrilldownTasksSlice';
import { addUsers } from 'state/normalized/insightDrilldownUsers/insightDrilldownUsersSlice';
import { addCapacityManagement } from 'state/normalized/insightDrilldownCapacityManagement/insightDrilldownCapacityManagmentSlice';
import { addEvents } from 'state/normalized/insightDrilldownEvents/insightDrilldownEventsSlice';

type DrilldownConfig = {
  addToStore: ActionCreatorWithPayload<
    DrilldownJsonApiResponse['data'],
    string
  >;
};

const drilldownActions: Record<DrillDownCategory, DrilldownConfig> = {
  [DrillDownCategory.REQUESTS]: {
    addToStore: addRequests,
  },
  [DrillDownCategory.PROJECTS]: {
    addToStore: addProjects,
  },
  [DrillDownCategory.TASKS]: {
    addToStore: addTasks,
  },
  [DrillDownCategory.USERS]: {
    addToStore: addUsers,
  },
  [DrillDownCategory.CAPACITY_MANAGEMENT]: {
    addToStore: addCapacityManagement,
  },
  [DrillDownCategory.EVENTS]: {
    addToStore: addEvents,
  },
};

export default drilldownActions;
